var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28336 9.33898C7.47705 9.13046 7.75362 9 8.06066 9L17.9393 9C18.2522 9 18.5334 9.13544 18.7275 9.35087M7.28336 9.33898C7.10753 9.52828 7 9.78191 7 10.0607L7 17M7.28336 9.33898L10.3103 6.31098C10.5023 6.11885 10.7676 6 11.0607 6L20.9393 6C21.2321 6 21.4972 6.11863 21.6891 6.31044M18.7275 9.35087C18.8969 9.53884 19 9.78771 19 10.0607L19 19.9393C19 20.236 18.8782 20.5043 18.6818 20.6968M18.7275 9.35087L21.6891 6.31044M21.6891 6.31044C21.8812 6.5024 22 6.76765 22 7.06066L22 16.9393C22 17.1994 21.9064 17.4377 21.751 17.6222L18.6818 20.6968M18.6818 20.6968C18.4905 20.8844 18.2284 21 17.9393 21H11",
    stroke: "#050022",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 21,
    r: 1.5,
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.bcc12eb735712d8ebfd3c46c92b99819.svg";
export { ForwardRef as ReactComponent };